import React from 'react';


const Header = (props) => {

    //eslint-disable-next-line
    let whatever = import.meta.env;
    return (
        <div 
            style={{ padding: "2em" }} 
            className={import.meta?.env?.VITE_SSO ==="true" ? 'client-sso' : 'p-8'}
        >
            <img 
                alt={props?.config?.data?.ApplicationNameParameter || 'Lite QuickSight Reporting Portal'} 
                src="/logo.png" 
                className='w-full rounded-md'
                style={{backgroundColor: props?.config?.data?.TransparentLogo ? props?.config?.data?.PrimaryColorParameter: undefined, padding:'20px'}}
            />
        </div> 
    );
};

export default Header;